// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Pm6I","buttons":"RemoveExpirationActionButtons_buttons__3kmKa"};